export default "__VITE_ASSET__D7QA93un__"